export default __webpack_public_path__ + "static/media/Database.e4926506.svg";